export default __webpack_public_path__ + "static/media/sell (5).64e0fdff.png";